module.exports = __webpack_public_path__ + "img/projectIcon.47c10ce0.svg";